import { styled, Typography } from '@mui/material';

export const SubHeaderText = styled(Typography)(
  ({ theme }) => `
    font-size: 16px;
    font-weight: 300;
    color: '${theme.palette.brand.black}';
    margin-top: 10px;
  `,
);

export const SubHeader = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
`;
